export default __webpack_public_path__ + "static/media/grow.33f2f126.svg";